var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllEmptyData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 160,
    viewBox: "0 0 164 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 89"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M162.27 80C162.27 91.8811 159.675 103.168 155.015 113.308C142.388 140.865 114.561 160 82.2695 160C49.9776 160 22.1506 140.865 9.52359 113.308C4.86413 103.168 2.26953 91.8811 2.26953 80C2.26953 35.8162 38.0858 0 82.2695 0C126.453 0 162.27 35.8162 162.27 80Z",
    fill: "#F4F7FC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 214"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0696 113.1H105.87C101.396 113.1 97.7696 109.473 97.7696 105C97.7696 100.526 101.396 96.8999 105.87 96.8999H25.7896C25.7829 96.8999 25.7762 96.8999 25.7695 96.8999H23.0695C17.1049 96.8999 12.2695 101.735 12.2695 107.7V113.1L23.0696 113.1Z",
    fill: "url(#paint0_linear_7854_1684)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 83",
    d: "M75.2695 107.7C75.2695 101.735 70.4342 96.8999 64.4695 96.8999H24.8695V123.9C24.8695 129.865 29.7049 134.7 35.6695 134.7H75.2695V107.7Z",
    fill: "url(#paint1_linear_7854_1684)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 82",
    d: "M44.6694 34.8C44.6694 28.8353 49.5048 24 55.4694 24H125.669V115.8C125.669 126.238 117.208 134.7 106.769 134.7H44.6694V34.8Z",
    fill: "url(#paint2_linear_7854_1684)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.67 45.6H52.7695C58.7342 45.6 63.5695 40.7647 63.5695 34.8C63.5695 28.8353 58.7342 24 52.7695 24H125.67C131.634 24 136.47 28.8353 136.47 34.8C136.47 40.7647 131.634 45.6 125.67 45.6Z",
    fill: "url(#paint3_linear_7854_1684)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.6696 124.8V134.7H34.801C40.2542 134.683 44.6696 130.257 44.6696 124.8Z",
    fill: "#D4D8E1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.272 96.9L24.8694 96.9L24.8694 100.5C24.8694 98.5127 23.259 96.9014 21.272 96.9Z",
    fill: "#D0D4DE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 215"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 87",
    x: 69.8696,
    y: 75.3003,
    width: 46.8,
    height: 7.2,
    rx: 2.7,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 91",
    x: 57.2695,
    y: 75.3003,
    width: 7.2,
    height: 7.2,
    rx: 2.7,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 88",
    x: 69.8696,
    y: 91.5,
    width: 36.9,
    height: 7.2,
    rx: 2.7,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 92",
    x: 57.2695,
    y: 91.5,
    width: 7.2,
    height: 7.2,
    rx: 2.7,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 90",
    x: 69.8696,
    y: 59.1001,
    width: 46.8,
    height: 7.2,
    rx: 2.7,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 93",
    x: 57.2695,
    y: 59.1001,
    width: 7.2,
    height: 7.2,
    rx: 2.7,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 213"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.089 77.3883C145.366 77.2054 144.928 76.4712 145.111 75.7484L145.773 73.1309C145.956 72.4081 146.69 71.9703 147.413 72.1532C148.136 72.3361 148.573 73.0702 148.391 73.7931L147.728 76.4106C147.546 77.1334 146.811 77.5711 146.089 77.3883ZM150.18 80.9843C149.9 80.2933 150.233 79.5061 150.924 79.226L153.426 78.2116C154.117 77.9315 154.905 78.2645 155.185 78.9555C155.465 79.6465 155.132 80.4337 154.441 80.7138L151.939 81.7282C151.248 82.0083 150.46 81.6753 150.18 80.9843ZM151.317 86.1523C150.596 85.962 149.858 86.3921 149.667 87.1129C149.477 87.8338 149.907 88.5725 150.628 88.7628L153.238 89.4521C153.959 89.6424 154.698 89.2123 154.888 88.4915C155.079 87.7706 154.649 87.0319 153.928 86.8416L151.317 86.1523Z",
    fill: "#A1A5AC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 184"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15",
    x: 135.679,
    y: 112.686,
    width: 1.80469,
    height: 11.4449,
    transform: "rotate(-45 135.679 112.686)",
    stroke: "url(#paint4_linear_7854_1684)",
    strokeWidth: 1.80469
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 16",
    filter: "url(#filter0_i_7854_1684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.999 119.645C136.593 118.239 136.593 115.959 137.999 114.554L138.823 113.73C140.229 112.324 142.508 112.324 143.914 113.73L156.839 126.655C158.245 128.061 158.245 130.34 156.839 131.746L156.015 132.57C154.609 133.975 152.33 133.975 150.924 132.57L137.999 119.645Z",
    fill: "url(#paint5_linear_7854_1684)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 48",
    d: "M144.569 93.3001C144.569 107.218 133.287 118.5 119.369 118.5C105.452 118.5 94.1694 107.218 94.1694 93.3001C94.1694 79.3825 105.452 68.1001 119.369 68.1001C133.287 68.1001 144.569 79.3825 144.569 93.3001Z",
    fill: "#D9DCE0",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 48 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.369 110.4C128.814 110.4 136.469 102.744 136.469 93.3001C136.469 83.856 128.814 76.2001 119.369 76.2001C109.925 76.2001 102.269 83.856 102.269 93.3001C102.269 102.744 109.925 110.4 119.369 110.4ZM119.369 118.5C133.287 118.5 144.569 107.218 144.569 93.3001C144.569 79.3825 133.287 68.1001 119.369 68.1001C105.452 68.1001 94.1694 79.3825 94.1694 93.3001C94.1694 107.218 105.452 118.5 119.369 118.5Z",
    fill: "url(#paint6_linear_7854_1684)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Line 7",
    opacity: 0.4,
    filter: "url(#filter1_f_7854_1684)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 138.623,
    y1: 120.646,
    x2: 153.623,
    y2: 135.646,
    stroke: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_7854_1684",
    x: 136.045,
    y: 110.875,
    width: 21.8485,
    height: 22.7487,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.9,
    dy: -1.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.362969 0 0 0 0 0.386115 0 0 0 0 0.420833 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_7854_1684"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_7854_1684",
    x: 134.27,
    y: 116.293,
    width: 23.707,
    height: 23.707,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_7854_1684"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7854_1684",
    x1: 56.6202,
    y1: 112.609,
    x2: 56.6376,
    y2: 97.7376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C5CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953081,
    stopColor: "#B1B4BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7854_1684",
    x1: 48.7506,
    y1: 133.553,
    x2: 48.9267,
    y2: 98.8555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8ADB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFD3DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7854_1684",
    x1: 87.2891,
    y1: 131.342,
    x2: 87.0153,
    y2: 56.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D7E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D5DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7854_1684",
    x1: 105.42,
    y1: 24,
    x2: 105.42,
    y2: 47.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E5EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.970777,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7854_1684",
    x1: 134.725,
    y1: 114.578,
    x2: 139.889,
    y2: 115.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0B8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#757982"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7854_1684",
    x1: 152.695,
    y1: 119.875,
    x2: 136.708,
    y2: 132.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBCED8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5C9D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7854_1684",
    x1: 98.6694,
    y1: 75.3001,
    x2: 144.569,
    y2: 112.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9BEC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABB0B9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllEmptyData);
export default __webpack_public_path__ + "static/media/ill_empty_data.c8cad11fbd94302a44c71574cee7e432.svg";
export { ForwardRef as ReactComponent };